import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { signUp } from "../actions/member";
import { connect } from "react-redux";
import EyeClosed from "../images/eyeClosedIcon.svg";
import EyeOpen from "../images/eyeOpenIcon.svg";
import { colors } from "../constants/colors";
function SignUp(props) {
  const [form] = Form.useForm();
  const [loading, handleChangeLoading] = useState(false);

  function handleSubmit(values) {
    values.role = "user";
    if (values.email.indexOf("@angelo.network") > -1) {
      values.role = "dev";
    }
    props.signUp(values).then((result) => {
      const { isSuccess, err } = result;
      if (isSuccess) {
        props.handleResgiterSuccess();
      } else {
        message.warn(err.message);
      }
      form.resetFields();
      handleChangeLoading(false);
    });
  }

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={(values) => {
        handleSubmit(values);
      }}
    >
      <h4 style={{ color: colors.gencBlue }}>Create you GenC Space</h4>
      <Form.Item
        name="email"
        rules={[
          {
            type: "email",
            message: "The input is not valid E-mail!",
          },
          {
            required: true,
            message: "Please input your E-mail!",
          },
        ]}
        label={
          <label
            style={{
              color: colors.gencGrey,
              fontSize: "16px",
              fontWeight: "400",
              margin: 0,
            }}
          >
            Email
          </label>
        }
      >
        <Input size="large" />
      </Form.Item>
      <Form.Item
        name="password"
        label={
          <label
            style={{
              color: colors.gencGrey,
              fontSize: "16px",
              fontWeight: "400",
              margin: 0,
            }}
          >
            Password
          </label>
        }
        rules={[
          {
            required: true,
            message: "Please input your password!",
          },
        ]}
        hasFeedback
      >
        <Input.Password
          size="large"
          iconRender={(visible) =>
            visible ? (
              <img src={EyeOpen} alt="eye open" />
            ) : (
              <img src={EyeClosed} alt="eye closed" />
            )
          }
        />
      </Form.Item>

      <Form.Item
        name="confirm"
        label={
          <label
            style={{
              color: colors.gencGrey,
              fontSize: "16px",
              fontWeight: "400",
              margin: 0,
            }}
          >
            Confirm Password
          </label>
        }
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "Please confirm your password!",
          },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                "The two passwords that you entered do not match!"
              );
            },
          }),
        ]}
      >
        <Input.Password
          size="large"
          iconRender={(visible) =>
            visible ? (
              <img src={EyeOpen} alt="eye open" />
            ) : (
              <img src={EyeClosed} alt="eye closed" />
            )
          }
        />
      </Form.Item>

      <Form.Item
        name="nickname"
        rules={[
          {
            required: true,
            message: "Please input your nickname!",
            whitespace: true,
          },
        ]}
        label={
          <label
            style={{
              color: colors.gencGrey,
              fontSize: "16px",
              fontWeight: "400",
              margin: 0,
            }}
          >
            Nickname (optional)
          </label>
        }
      >
        <Input size="large" />
      </Form.Item>

      <Form.Item style={{ textAlign: "center" }}>
        <Button
          loading={loading}
          type="primary"
          htmlType="submit"
          style={{
            border: "none",
            backgroundColor: colors.gencRed,
            fontWeight: "700",
            fontSize: "20px",
            borderRadius: "10px",
            width: "70%",
            height: "56px",
          }}
        >
          Register
        </Button>
      </Form.Item>
    </Form>
  );
}

const mapStateToProps = (state) => ({
  member: state.member || {},
});

const mapDispatchToProps = (dispatch) => {
  return {
    signUp: (data) => signUp(data),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
